module.exports = __webpack_public_path__ + "img/blanco(nuevo).d5e24cc5.png";